import React from "react"
import { useSelector } from "react-redux"

import { QidDatapoint } from "server/models"
import {
    StoreType,
    QidResultType,
} from "client/store"
import { TableColumn } from "client/components"

import FormatedResult from "../formatedResult"

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const cellMinWidth = "100px"
    const columns: TableColumn[] = [
        {
            field: "failureMode",
            cellMinWidth: "250px",
            formatter: (data: QidDatapoint | QidResultType) => {
                const datapoint = data as QidDatapoint
                if (datapoint.id && datapoint.failureModeId && datapoint.failureMode) {
                    return (
                        <span title={datapoint.failureMode.name}>
                            {datapoint.failureMode.name}
                        </span>
                    )
                }
                if (datapoint.id && !datapoint.failureModeId) {
                    return lang.failureMode
                }
                if (!datapoint.id) { // QidResultType
                    return <b>{lang.total}</b>
                }
                return null
            },
        },
        {
            field: "sd",
            header: "SD",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.sd} />,
        },
        {
            field: "su",
            header: "SU",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.su} />,
        },
        {
            field: "dd",
            header: "DD",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.dd} />,
        },
        {
            field: "du",
            header: "DU",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.du} />,
        },
        {
            field: "ne",
            header: "NE",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.ne} />,
        },
        {
            field: "np",
            header: "NP",
            cellMinWidth,
            formatter: (data: QidResultType) => <FormatedResult data={data.np} />,
        },
    ]

    return columns
}
export default Columns
